import { useContext } from "react";
import AppInfoContext from "src/provider/state-manager/appInfoProvider";

function SvgComponent(props: any) {
  const {
    info: { theme },
  } = useContext(AppInfoContext);

  return (
    <svg
      width={88}
      height={88}
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M44.0013 60.3346V44.0013M44.0013 27.668H44.0421M84.8346 44.0013C84.8346 66.5529 66.5529 84.8346 44.0013 84.8346C21.4497 84.8346 3.16797 66.5529 3.16797 44.0013C3.16797 21.4497 21.4497 3.16797 44.0013 3.16797C66.5529 3.16797 84.8346 21.4497 84.8346 44.0013Z"
        stroke={theme["#0D968F"]}
        strokeWidth="5.88"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgComponent;
